export const apiUrl = process.env.VUE_APP_BACKEND_API_URL || '';
export const appName = process.env.VUE_APP_NAME;
export const riskAssessmentBaseUrl =
  process.env.VUE_APP_RISK_ASSESSMENT_URL || '';
// NOTE: intentionally no production-domain fallback here — this value is
// used as a login-redirect allowlist origin (see utils/redirectWhitelist.ts).
// If misconfigured, it should fail closed (reject all satellite redirects)
// rather than silently allow the production regulation domain.
export const regulationDatabaseUrl =
  process.env.VUE_APP_REGULATION_DATABASE_URL || '';
export const isTrialEnvironment =
  process.env.VUE_APP_IS_TRIAL_ENV === 'true' || false;

export const trialLoginUrl =
  process.env.VUE_APP_ENV === 'production'
    ? 'https://trial.sdsocr.com/#/login'
    : 'https://stg.trial.sdsocr.com/#/login';

export const contractedLoginUrl =
  process.env.VUE_APP_ENV === 'production'
    ? 'https://sdsocr.com/#/login'
    : 'https://stg.sdsocr.com/#/login';

export const RISK_ASSESSMENT_USER_GUIDE_URL =
  'https://file.sdsocr.com/Chemican_Risk%20Assessment%20User%20Guide.pdf';
